import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { importState, startImport } from '@/app/api';

interface IInitialState {
  lastImport: string;
  importing: boolean;
}

const initialState: IInitialState = {
  lastImport: '',
  importing: false,
};

export const fetchLastImport = createAsyncThunk(
  'import/fetchLastImport',
  async (_, { rejectWithValue }) => {
    try {
      const res = await importState();
      if (res) {
        const date = new Date(res.last_import_date);
        return {
          importing: res.importing,
          lastImport: `${date.toLocaleDateString()} | ${date.toLocaleTimeString(_ as undefined, {
            hour: '2-digit',
            minute: '2-digit',
          })}`,
        };
      }
      return { lastImport: 'N/A', importing: false };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchImport = createAsyncThunk(
  'import/fetchImport',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      await startImport();

      dispatch(fetchLastImport());
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const importSlice = createSlice({
  name: 'import',
  initialState,
  reducers: {
    startSyncImport: (state) => {
      state.importing = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLastImport.fulfilled, (state, action) => {
        state.lastImport = action.payload.lastImport;
        state.importing = action.payload.importing;
      })
  },
});

export const { startSyncImport } = importSlice.actions;
export default importSlice.reducer;
